<template>
  <el-col :span="24">
    <el-col :span="24" >
      <div style="text-align: left;margin-top: 10px;margin-bottom: 20px;">
        <el-col :span="12" >
          <el-radio-group v-model="radio1">
            <el-radio-button v-for="(item,index) in DaySafter_list" :key="index" :label="item" ></el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="12" >
          <div style="text-align: left;display:flex;justify-content: space-evenly;">
            <div style="height: 40px;line-height: 40px;display:flex;">
              <span style="margin-right: 5px;">实付为零：</span>
              <span class="bjwarning" style="width: 50px;height: 40px;line-height: 40px;display: block;border-radius: 10px;"></span>
            </div>
            <div style="height: 40px;line-height: 40px;display:flex;margin-left: 20px;">
              <span style="margin-right: 5px;">四人及以上的场次：</span>
              <span class="bjerror" style="width: 50px;height: 40px;line-height: 40px;display: block;border-radius: 10px;"></span>
            </div>
            <el-popover
             style="margin-left: 50px;"
                placement="top-start"
                title="注意"
                width="200"
                trigger="hover"
                content="">
                <div>
                  1.后付费的场次订单，无特殊情况不使用！（需备注）<br>2.每一条场次订单，需要填写正确，后续会根据订单号匹配支付账单！<br>3.用户来源的中如果选择其他，需要明确备注清楚！<br>4.一天下班前，需要结束所有订单！（重要）
                </div>
                <el-button  type="primary" slot="reference" >注意事项</el-button>
              </el-popover>
              <el-popover
               style="margin-left: 20px;"
                  placement="top-start"
                  title="注意"
                  width="200"
                  trigger="hover"
                  content="">
                  <div>
                   <!-- 1.线下路过、电话预定、业务招待：银豹流水号为必填<br>2.线上预订-大众点评/美团、线上团购-大众点评/美团、线上预订-口碑团购、线上预订-b站、线上预订-猫眼、线上预订-抖音、微盟：第三方流水号为必填<br>3.其他：备注不能为空（订单号及第三方支付流水号不是必填） -->
                    <el-image
                        style="width: 150px; height: 100px"
                        :src="url"
                        :preview-src-list="srcList">
                      </el-image>
                  </div>
                  <el-button slot="reference" >录入规则</el-button>
                </el-popover>
                <div style="height: 40px;line-height: 40px;display:flex;margin-left: 20px;float: right;">
                  <el-button type="danger" @click="add_information_paichang()" >添加排场</el-button>
                </div>
          </div>
        </el-col>
      </div>
      <div style="text-align: left;line-height: 50px;text-indent: 5px;color: #909399;">
        统计：
        <span style="color: rgb(214 197 73);">未退款-原价金额：{{turnover_sum}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(77 175 213);">未退款-实收金额：{{paid_amount_sum}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(77 175 213);">退款条数：{{refund_sum}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(195 133 184);">总人数：{{people_sum}}</span>
        <span style="color: rgb(195 133 184);float: right;">
          <el-checkbox v-model="time_sort">按时间排序</el-checkbox>
          <el-checkbox v-model="checked_isshow">不显示已结束场次</el-checkbox>
        </span>
      </div>
    </el-col>
    <el-table :data="
      tableData.filter(
        (data) =>
          !search || data.name.toLowerCase().includes(search.toLowerCase())
      )
    "
    border
    height="735px"
    :span-method="objectSpanMethod"
    :row-class-name="tableRowClassName"
     style="width: 100%"
      highlight-current-row
      @current-change="handleCurrentChange"
     >
     <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
     <el-table-column label="订单信息" width="130" prop="time_start">
       <template slot-scope="scope">
         {{game_name(scope.row.game_id).name}}<br>
         {{ret_YearMonthDate(scope.row.time_start)}}<br>
         {{ret_YearMonthDateHoursMin(scope.row.time_start)}} ~ {{ret_YearMonthDateHoursMin(scope.row.time_end)}}<br>
         {{scope.row.hall_type}}厅<br>
         陪玩{{scope.row.play_with_count}}人<br>
         {{scope.row.aftert_pay_status==1?"后付费":"先付费"}}<br>
       </template>
     </el-table-column>
      <el-table-column align="center" label="排场操作"  width="200">
        <template slot-scope="scope">
            <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;"  type="warning" @click="modify_time(scope.row)">修改</el-button>
            <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;" v-show="scope.row.order_start_status<2"  type="primary" @click="add_information(scope.row)">添加</el-button>
            <el-popconfirm
              v-show="scope.row.order_start_status==0"
              title="确认删除此条排场？"
               style="margin-right: 10px;"
              @confirm="delete_information_order(scope.row)"
            >
              <el-button style="margin-bottom: 10px;"  slot="reference" type="danger">删除</el-button>
            </el-popconfirm>
            <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;"   type="primary" @click="all_preservation(scope.row)">保存</el-button>
            <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;"  type="primary" v-show="scope.row.order_start_status==0" @click="start_game(scope.row)">开始</el-button>
            <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;" v-show="scope.row.order_start_status==1"  type="danger" @click="end_game(scope.row)">结束</el-button>
        </template>
      </el-table-column>
      <el-table-column  label="手机号" width="120"  prop="phone">
        <template slot-scope="scope" >
          <input type='text' v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" style="width: 80%;height: 38px;border: 1px solid rgb(220 223 230);border-radius: 4px;" :value="scope.row.phone" @blur="phone_edit($event,scope.row)"  >
        </template>
      </el-table-column>
      <el-table-column label="人数" width="80" align="center" prop="people_count">
        <template slot-scope="scope">
          <el-select style="width: 100%;"  v-show="scope.row.children_number!=0" :disabled="scope.row.order_start_status==0?false:(scope.row.modify_time==0?false:(scope.row.modify_time>0?true:scope.row.is_disabled==1?true:false))" :value="scope.row.people_count" @change="people_count_edit($event,scope.row)" placeholder="请选择">
            <el-option v-for="item in select_options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="用户来源" width="150"  prop="people_source">
        <template slot-scope="scope">
          <el-select style="width: 100%;" v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" :value="scope.row.people_source" @change="people_source_edit($event,scope.row)" placeholder="请选择">
            <el-option v-for="item in user_source"  :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="线下转线上" width='70'  prop="offline_conversion">
        <template slot-scope="scope">
          <el-checkbox v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" :value="(scope.row.offline_conversion==1?true:false)" @change="offline_conversion_edit($event,scope.row)" ></el-checkbox>
          <!-- {{scope.row.children_number==0?"":(scope.row.offline_conversion==1?'是':'否')}} -->
        </template>
      </el-table-column>

      <el-table-column label="私域" width='50'  prop="private_domain">
        <template slot-scope="scope">
          <el-checkbox v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" :value="(scope.row.private_domain==1?true:false)" @change="private_domain_edit($event,scope.row)"></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column label="付款方式" width="120" prop="payment_mode">
        <template slot-scope="scope">
          <el-select style="width: 100%;" v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" :value="scope.row.payment_mode" @change="payment_mode_edit($event,scope.row)" placeholder="请选择">
            <el-option v-for="item in payment_method_agent" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="原价金额" width="50"  prop="turnover">
        <template slot-scope="scope">
          {{scope.row.turnover}}
          <!-- <input type='text' style="width: 80%;height: 38px;border: 1px solid rgb(220 223 230);border-radius: 4px;" :value="scope.row.turnover" @blur="turnover_edit($event,scope.row)"  > -->
        </template>
      </el-table-column>
      <el-table-column label="实收金额" width="70"  prop="net_receipts">
        <template slot-scope="scope">
          <input type='text' v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" style="width: 80%;height: 38px;border: 1px solid rgb(220 223 230);border-radius: 4px;" :value="scope.row.net_receipts" @blur="net_receipts_edit($event,scope.row)"  >
        </template>
      </el-table-column>
      <el-table-column label="订单号" width="190"  prop="payment_serial_number">
        <template slot-scope="scope">
          <input type='text' v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" style="width: 90%;height: 38px;border: 1px solid rgb(220 223 230);border-radius: 4px;" :value="scope.row.payment_serial_number" @blur="payment_serial_number_edit($event,scope.row)"  >
        </template>
      </el-table-column>
      <el-table-column label="服务人员" width='170' prop="waiter">
        <template slot-scope="scope">
<!--          <el-autocomplete
                     class="inline-input"
                     v-show="scope.row.children_number!=0"
                     :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false"
                      v-model="scope.row.waiter"
                     :fetch-suggestions="querySearch"
                     placeholder="请输入内容"
                     :multiple="true"
           ></el-autocomplete> -->
          <el-select v-model="scope.row.waiter"
             v-show="scope.row.children_number!=0"
             :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" multiple placeholder="请选择">
             <el-option
               v-for="item in ShopWaiter"
               :key="item.value"
               :value="item.value">
             </el-option>
           </el-select>
        </template>

      </el-table-column>
      <el-table-column label="备注" width='150' prop="remarks">
        <template slot-scope="scope">
          <el-input  v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" type="textarea" v-model="scope.row.remarks" @blur="remarks_edit($event,scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="left" label="信息操作" width="250">
        <template slot-scope="scope">
          <div v-show="scope.row.order_refund_status==1">
            已退款
          </div>
          <div v-show="scope.row.order_refund_status!=1">
            <el-button  style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;"  type="warning" v-show="scope.row.children_number!=0" @click="modify_information(scope.row)" >{{scope.row.modify_time==0?"保存":scope.row.is_disabled==1?'修改':"保存"}}</el-button>

            <el-popconfirm
             v-show="scope.row.children_number!=0"
              title="确认删除此条排场？"
              @confirm="delete_information(scope.row)"
            >
              <el-button slot="reference" v-if="scope.row.order_start_status==0" type="danger">删除</el-button>
            </el-popconfirm>
            <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;" v-show="scope.row.children_number!=0" v-if="scope.row.order_start_status!=0"  type="info" @click="abnormal_end_game(scope.row)">异常退款</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="补差价类型" width="150"  prop="extra_money_type">
             <template slot-scope="scope">
               <el-select style="width: 100%;" v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" :value="scope.row.extra_money_type" @change="extra_money_type_edit($event,scope.row)" placeholder="请选择">
                 <el-option v-for="item in extra_money_list"  :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
               </el-select>
             </template>
           </el-table-column>
      <el-table-column  label="补差价" width="60"  prop="extra_money">
             <template slot-scope="scope" >
               <input type='text' v-show="scope.row.children_number!=0" :disabled="scope.row.modify_time==0?false:scope.row.is_disabled==1?true:false" style="width: 80%;height: 38px;border: 1px solid rgb(220 223 230);border-radius: 4px;" :value="scope.row.extra_money" @blur="extra_money_edit($event,scope.row)"  >
             </template>
           </el-table-column>
    </el-table>
    <el-dialog :title="paichang_title" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible_paichang" width="30%">
      <el-form  :model="form"  :label-width="formLabelWidth">
        <el-form-item label="时间:">
          <el-date-picker
                v-model="value1"
                type="datetime"
                placeholder="选择时间"
                 value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                 :picker-options="pickerOptions1"
                >
              </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="厅位:">
          <el-select style="width: 100%;"  v-model="hall_value" placeholder="请选择">
            <el-option v-for="item in hall_list" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="游戏名称:">
          <el-select style="width: 100%;"  v-model="shop_game_value" :disabled="this.dialogFormVisible_paichang_start" placeholder="请选择">
            <el-option v-for="item in shop_game" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="陪玩人数:">
          <el-select style="width: 100%;"  v-model="Playwith_value" placeholder="请选择">
            <el-option v-for="item in Playwith" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏时长:">
          <el-select style="width: 100%;"  v-model="time_value" placeholder="请选择">
            <el-option v-for="item in time_type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付费状态:">
          <el-checkbox v-model="aftert_pay_status">后付费</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelStartGame">取 消</el-button>
        <el-button type="primary" @click="AddOstentation">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="退款信息补充"  :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible_abnormal"  top="4%" width="30%">
      <el-form  :label-width="formLabelWidth">
        <el-form-item label="退款流水号:">
          <el-input v-model="yinbaoabnormal" placeholder="请输入退款流水号"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input type="textarea" v-model="desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelAbnormal">取 消</el-button>
        <el-button type="primary" @click="startGame_abnormal">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="崩溃信息补充"  :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible_collapse"  top="4%" width="30%">
      <el-form  :label-width="formLabelWidth">
        <el-form-item label="崩溃次数:">
          <el-input v-model="number_collapse" placeholder="请输入崩溃次数"></el-input>
        </el-form-item>
        <el-form-item label="异常描述:">
          <el-input type="textarea" v-model="desc_collapse"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelcollapse">取 消</el-button>
        <el-button type="primary" @click="startGame_collapse">确 定</el-button>
      </div>
    </el-dialog>
  </el-col>
</template>
<script>
  import {
    protocol_ZgrShopOstentation_list,
    protocol_ZgrShopOstentation_select_signature_status,
    protocol_ZgrShopOstentation_send_sms,
    protocol_ZgrShopOstentation_eidt,
    protocol_ZgrShopOstentation_add,
    protocol_ZgrShopOstentation_send_register,
    protocol_ZgrShopOstentation_delete,
    protocol_ZgrShopOstentationOrder_add,
    protocol_ZgrShopOstentationOrder_eidt,
    protocol_ZgrShopOstentationOrder_delete,
    protocol_ZgrShopOstentationOrder_list,
    protocol_ZgrShopStart_game,
    protocol_ZgrShopEnd_game,
    protocol_ZgrShopEnd_game_abnormal,
    protocol_data_ShopWaiter_get
  } from '@/assets/js/network/request'
  import {
    gUtilityTime
  } from '@/assets/js/utility/UtiltiyTime'

  import {
    gGameData
  } from '@/assets/js/data/GameData'
  import {
    gAccount
  } from '@/assets/js/data/Account'
  import payment_methodagent from "@/assets/js/payment_methodagent.json";
  export default {
    data() {
      return {
                options: [{
                  value1: '1111'

                }, {
                  value1: '双皮奶'

                }, {
                  value1: '蚵仔煎'

                }, {
                  value1: '龙须面'

                }, {
                  value1: '北京烤鸭'
                }],
               //options_value1: ['黄金糕','双皮奶','111'],
                options_value1: [],

        url: 'http://cjword.oss-cn-beijing.aliyuncs.com/paichang/tishi.jpg',
        srcList: [
          'http://cjword.oss-cn-beijing.aliyuncs.com/paichang/tishi.jpg',
        ],
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
        checked_isshow:true,
        time_sort:true,
        modify_div:'',
        tableData: [],
        shop_game:[],
        search: '',
        dialogFormVisible: false,
        dialogFormVisible_modify:false,
        dialogFormVisible_paichang:false,
        dialogFormVisible_abnormal:false,
        dialogFormVisible_collapse:false,
        btnChangeEnable:false,
        aftert_pay_status:false,
        form: {
          name: '',
          phone:"",
          turnover:0,
          paid_amount:0,
          volume_code:'',
          waiter:'',
          desc:"",
          payment_serial_number:""
        },
        checked:false,
        is_checked:false,
        Playwith_value:0,
        Playwith:[
          {
            value: 0,
            label: '0'
          },{
            value: 1,
            label: '1'
          }
          ],
        shop_game_value:'',
        time_value:20,
        time_type:[
          {
            value: 20,
            label: '20分钟'
          },{
            value: 30,
            label: '30分钟'
          },{
            value: 40,
            label: '40分钟'
          },{
            value: 50,
            label: '50分钟'
          },{
            value: 60,
            label: '60分钟'
          }
          ],
        shop_game_value:'',
        select_value: "1",
        select_options: [{
          value: 1,
          label: '1'
        }, {
          value: 2,
          label: '2'
        }, {
          value: 3,
          label: '3'
        }, {
          value: 4,
          label: '4'
        }, {
          value: 5,
          label: '5'
        }, {
          value: 6,
          label: '6'
        }],
        hall_list:[{
          value: '1',
          label: '1'
        }, {
          value: '2',
          label: '2'
        }],
        extra_money_list:[
          {
            value: 1,
            label: '支付宝',
          },{
          value: 2,
          label: '微信',
          },
        ],
      user_source:[{
        value: 13,
        label: '小程序'
      }, {
        value: 4,
        label: '线上预订-大众点评/美团'
      }, {
        value: 5,
        label: '线上团购-大众点评/美团'
      }, {
        value: 9,
        label: '线上预订-抖音'
      },{
        value: 12,
        label: '私域'
      },{
        value: 1,
        label: '线下路过',
      }, {
        value: 2,
        label: '电话预定'
      }, {
        value: 3,
        label: '业务招待'
      }, {
        value: 6,
        label: '线上预订-口碑团购'
      }, {
        value: 7,
        label: '线上预订-b站'
      }, {
        value: 8,
        label: '线上预订-猫眼'
      }, {
        value: 10,
        label: '微盟'
      },{
        value: 11,
        label: '其他'
      }],
        user_source_value:'',
        is_payment_method:false,
        payment_method:[],
        payment_method_agent:[],
        payment_method_value:'',
        hall_value:"1",
        formLabelWidth: '120px',
        click_index: 0,
        Account_shop: '',
        value1: '',
        radio1:'',
        DaySafter_list:[],
        paid_amount_sum:'',
        refund_sum:'',
        turnover_sum:"",
        people_sum:'',
        mergeLineArr:[],
        paichang_title:"添加排场",
        modify_time_data:'',
        game_price:10,
        yinbaoabnormal:'',
        desc:'',
        number_collapse:0,
        desc_collapse:'',
        abnormal_div:'',
        collapse_div:"",
        loading:"",
        currentRow:"",
        config_hall_type:2,
        dialogFormVisible_paichang_start:false,
        ShopWaiter:[]
      }
    },
    methods: {
    shop_waiter_math(m_waiter)
    {
      if(m_waiter==null||m_waiter==""||m_waiter==undefined)
      {
         console.log([]);
        return [];
      }
      let item=[];
     if(m_waiter.indexOf(';')==-1)
     {
         if(m_waiter.length>0)
         {
          item.push(m_waiter);
         }
          return item;
     }else{
      let m=m_waiter.split(';')
      for (let i = 0; i < m.length; i++) {
          // let mm={'value':m[i]}
          // item.push(mm);
          // let mm={'value':m[i]}
          item.push(m[i]);
      }
      console.log(item);
      return item
      }
    },
    get_waiter_data(){
        let _this=this;
        _this.ShopWaiter=[];
        protocol_data_ShopWaiter_get().then((res1)=>{
          for(let i=0;i<res1.ret.length;i++){
           for (var i = 0; i < res1.ret.length; i++) {
             if(res1.ret[i].shop_waiter.length>0)
             {
               _this.ShopWaiter[i] = {"value" :res1.ret[i].shop_waiter };
             }
           }
          }
        })
    },
    querySearch(queryString, cb) {
      var restaurants =JSON.parse(JSON.stringify(this.ShopWaiter));
      var item = [];
      if(queryString!=""&&queryString!=null)
      {
        for (var i = 0; i < restaurants.length; i++) {
         if(queryString==restaurants[i].value)
         {
          continue;
         }
          item.push(restaurants[i])
        }
        for (var i = 0; i < item.length; i++) {
          item[i].value = `${queryString};${item[i].value}`;
        }
      }
      else{
         item=restaurants;
      }
      cb(item);
    },
      //手机号
      phone_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].phone=e.currentTarget.value
          }
        }
      },
      //补差价
      extra_money_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].extra_money=e.currentTarget.value
          }
        }
      },
      //人数
      people_count_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].people_count=e
            this.tableData[i].turnover=this.get_game_price(a.game_id)*e
            this.tableData[i].net_receipts=this.get_game_price(a.game_id)*e
          }
        }
      },
      //补差价类型
      extra_money_type_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].extra_money_type=e
          }
        }
      },
      //用户来源
      people_source_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].people_source=e
          }
        }
      },
      //付款方式
      payment_mode_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].payment_mode=e
          }
        }
      },
      //原价金额
      turnover_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].turnover=e.currentTarget.value
          }
        }
      },
      //实收金额
      net_receipts_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].net_receipts=e.currentTarget.value
          }
        }
      },
      //订单号
      payment_serial_number_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].payment_serial_number=e.currentTarget.value
          }
        }
      },
      //其他流水号
      thrid_party_code_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].thrid_party_code=e.currentTarget.value
          }
        }
      },
      //是否线上转线下
      offline_conversion_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].offline_conversion=(e==true?1:2)
          }
        }
      },
      //是否私域
      private_domain_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].private_domain=(e==true?1:0)
          }
        }
      },
      //备注
      remarks_edit(e,a){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_detail_id==a.ostentation_detail_id){
            this.tableData[i].remarks=e.currentTarget.value
          }
        }
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      tableRowClassName({ row }) {
        if(this.checked_isshow){
          if(row.order_start_status ==2 && row.aftert_pay_status!=1){
            return 'node-row';
          }
        }
        if(this.checked_isshow){
          if(row.people_source!=11){
            if(row.order_start_status==2 && row.aftert_pay_status==1 && row.payment_serial_number.length>=8 && row.is_show_hide==0){
              if(row.is_disabled==1){
                  return 'node-row';
              }
            }
          }

          if(row.people_source==11){
            if(row.order_start_status==2 && row.aftert_pay_status==1 && (row.remarks!=null || row.remarks!=""&& row.is_show_hide==0)){
              if(row.is_disabled==1){
                  return 'node-row';
              }
            }
          }

        }
        if (row.net_receipts == 0) {
          return 'warning-row';
        }
        if(row.totle_people_count >=4){
          return 'error-row';
        }
        return '';
      },
      //合并表格
      objectSpanMethod ({ row, column, rowIndex, columnIndex }){
          if (columnIndex < 3) {
              const _row = this.mergeLineArr[rowIndex];
              const _col = _row > 0 ? 1 : 0;
              return {
                  rowspan: _row,
                   colspan: _col
              }
          }
      },
      //处理合并表格数据
      mergeLineMethod (){
          this.mergeLineArr=[];
          let mergeLine=this.tableData
           mergeLine.forEach((res,i) => {
               if (i === 0) {
                   this.mergeLineArr.push(1);
                   this.mergeLineIndex= 0
               } else {
                   // 判断当前元素与上一个元素是否相同,是就给之前相同的第一个+1，并且数组添加一个0
                   if (mergeLine[i].id === mergeLine[i - 1].id) {
                       this.mergeLineArr[this.mergeLineIndex] += 1;
                       this.mergeLineArr.push(0);
                   } else {//如果与前一个不相同，则追加一个新从1开始的数字，此时更新mergeLineIndex的值
                       this.mergeLineArr.push(1);
                       this.mergeLineIndex= i;
                   }
               }
           });
       },
       //开始订单
       start_game(row){
         let _this=this;
         console.log(row)
         for(let i=0;i<this.tableData.length;i++){
           if(row.ostentation_order_id==this.tableData[i].ostentation_order_id){
             console.log(this.tableData[i].is_disabled)
             if(this.tableData[i].modify_time==0){
               _this.$message({
                 message: '请保存信息',
                 type: 'warning'
               });
               return;
             }
             if(this.tableData[i].is_disabled==0){
               _this.$message({
                 message: '请保存信息',
                 type: 'warning'
               });
               return;
             }
             if(this.tableData[i].aftert_pay_status==0){
                 if(this.tableData[i].people_source!=11){
                 if(this.tableData[i].payment_serial_number.length<=8){
                   _this.$message({
                     message: '请补全订单号',
                     type: 'warning',
                   });
                   return;
                 }
               }

               if(this.tableData[i].people_source==11){
                 if(this.tableData[i].remarks==null || this.tableData[i].remarks==""){
                   _this.$message({
                     message: '请补全备注',
                     type: 'warning',
                   });
                   return;
                 }
               }
             }

           }
         }
         _this.open_wait_for(1);
         protocol_ZgrShopStart_game(row.id,row.hall_type).then((res)=>{
           _this.open_wait_for(2);
           if(res.code==0){
             _this.$message({
               message: '订单开始成功',
               type: 'success'
             });
             _this.init_list(_this.radio1);
           }else{
             _this.$message({
               message: res.ret,
               type: 'warning'
             });
             _this.init_list(_this.radio1);
           }
         })
       },
       //结束订单弹窗
       collapse_end_game(row){
         this.dialogFormVisible_collapse=true;
         this.collapse_div=row;
         this.number_collapse=0;
         this.desc_collapse='';
       },
       //打开全局等待框
       open_wait_for(type){
         if(type==1){
           let loading = this.$loading({
                   lock: true,
                   text: '请求中，请耐心等待',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)',
            });
            this.loading=loading;
         }else{
           this.loading.close();
         }
       },
       //结束订单确定
       startGame_collapse(){
         let _this=this;
         _this.open_wait_for(1);
         protocol_ZgrShopEnd_game(_this.collapse_div.ostentation_order_id,_this.collapse_div.hall_type,_this.number_collapse,_this.desc_collapse).then((res)=>{
           _this.open_wait_for(2);
           if(res.code==0){
             _this.$message({
               message: '订单结束成功',
               type: 'success'
             });
             _this.dialogFormVisible_collapse=false;
             _this.collapse_div='';
             _this.number_collapse=0;
             _this.desc_collapse='';
             _this.init_list(_this.radio1);
           }else{
             _this.$message({
               message: res.ret,
               type: 'warning'
             });
             _this.init_list(_this.radio1);
           }
         })
       },
       //结束订单关闭
       cannelcollapse(){
         this.dialogFormVisible_collapse=false;
         this.collapse_div='';
         this.number_collapse=0;
         this.desc_collapse='';
       },
       //退款弹窗
       abnormal_end_game(row){
         this.dialogFormVisible_abnormal=true;
         this.abnormal_div=row;
         this.yinbaoabnormal='';
         this.desc='';
       },
       //退款确定
       startGame_abnormal(){
          let _this=this;
          if(this.yinbaoabnormal==""){
            _this.$message({
              message: '退款流水号不能为空',
              type: 'warning'
            });
            return;
          }
          _this.open_wait_for(1);
          protocol_ZgrShopEnd_game_abnormal(this.abnormal_div.ostentation_detail_id,this.yinbaoabnormal,this.desc).then((res)=>{
            _this.open_wait_for(2);
            if(res.code==0){
              _this.$message({
                message: '订单退款成功',
                type: 'success'
              });
              _this.dialogFormVisible_abnormal=false;
              _this.abnormal_div="";
              _this.yinbaoabnormal='';
              _this.desc='';
              _this.init_list(_this.radio1);
            }else{
              _this.$message({
                message: res.ret,
                type: 'warning'
              });
              _this.init_list(_this.radio1);
            }
          })
       },
       //关闭
       cannelAbnormal(){
         this.abnormal_div="";
         this.yinbaoabnormal='';
         this.desc='';
         this.dialogFormVisible_abnormal=false;
       },
       //结束订单
       end_game(row){
         let _this=this;
         for(let i=0;i<this.tableData.length;i++){
           if(row.ostentation_order_id==this.tableData[i].ostentation_order_id){
             console.log(this.tableData[i].is_disabled)
             if(this.tableData[i].modify_time==0){
               _this.$message({
                 message: '请保存信息',
                 type: 'warning'
               });
               return;
             }
             if(this.tableData[i].is_disabled==0){
               _this.$message({
                 message: '请保存信息',
                 type: 'warning'
               });
               return;
             }
             if(this.tableData[i].aftert_pay_status==0){

               if(this.tableData[i].people_source!=11){
                 if(this.tableData[i].payment_serial_number.length<=8){
                   _this.$message({
                     message: '请补全订单号',
                     type: 'warning',
                   });
                   return;
                 }
               }

               if(this.tableData[i].people_source==11){
                 if(this.tableData[i].remarks==null || this.tableData[i].remarks==""){
                   _this.$message({
                     message: '请补全备注',
                     type: 'warning',
                   });
                   return;
                 }
               }
             }

           }
         }
         this.collapse_end_game(row)
       },
       //修改场次信息
       modify_time(row){
         console.log(row)
         console.log(row.aftert_pay_status==0?false:true)
         this.modify_time_data=row;
         this.dialogFormVisible_paichang = true;
         this.paichang_title="修改排场";
         this.Playwith_value=row.play_with_count;
         // this.hall_value=(row.hall_type).toString();
         this.value1 = new Date(row.time_start*1000);
         this.time_value=(new Date(row.time_end) - new Date(row.time_start))/60
         this.shop_game_value =this.game_name(row.game_id).name;
         this.aftert_pay_status=row.aftert_pay_status==0?false:true;
         //游戏开始状态
         this.dialogFormVisible_paichang_start=row.order_start_status==0?false:true;
       },
      //添加场次
      add_information_paichang(){
        this.modify_time_data='';
        this.dialogFormVisible_paichang = true;
        this.dialogFormVisible_paichang_start=false;
        this.paichang_title="添加排场";
        this.Playwith_value=0;
        // this.hall_value="1";
        if(this.tableData.length!=0){
          if(this.currentRow!="" && this.currentRow!=null){
            this.value1 = new Date(this.currentRow.time_end*1000+1000*60*1);
          }else{
            this.value1 =new Date(this.tableData[this.tableData.length-1].time_end*1000+1000+1000*60*1)
          }
        }else{
          this.value1 =new Date()
        }
        this.shop_game_value ='';
        this.aftert_pay_status=false;
      },
      //添加信息
      add_information(row){
        this.modify_time_data=row;
        this.startGame();
        return
        this.dialogFormVisible = true;
        this.form.phone ='';
        this.select_value="1";
        this.modify_div='';
        this.payment_method_value='';
        this.user_source_value='';
        this.form.desc='';
        this.form.volume_code='';
        this.form.waiter='';
        this.form.payment_serial_number='';
        this.game_price=this.get_game_price(row.game_id);
        this.form.turnover=this.game_price;
        this.form.paid_amount=this.game_price;
        this.is_payment_method=false;
      },
      all_preservation(row){
        for(let i=0;i<this.tableData.length;i++){
          if(this.tableData[i].ostentation_order_id==row.ostentation_order_id){
            if(this.tableData[i].modify_time==0 || this.tableData[i].is_disabled!=1){
              if(this.startGame_modify(this.tableData[i])==false){
                break
              }
            }else{
              continue;
            }
          }
        }
      },
      //获取游戏价格
      get_game_price(id){
        for(let i=0;i<this.shop_game.length;i++){
          if(this.shop_game[i].id==id){
            return this.shop_game[i].price
          }
        }
      },

      // 删除信息
      delete_information(row){
        let _this=this;
        protocol_ZgrShopOstentation_delete(row.ostentation_detail_id).then(res=>{
            _this.$message({
              message: '删除成功',
              type: 'success'
            });
           _this.init_list(_this.radio1);
        })
      },
      // 删除场次
      delete_information_order(row){
        let _this=this;
        protocol_ZgrShopOstentationOrder_delete(row.id).then(res=>{
            _this.$message({
              message: '删除成功',
              type: 'success'
            });
           _this.init_list(_this.radio1);
        })
      },
      game_name(id){
        return  gGameData.getDataByID(id)
      },
      ret_YearMonthDate(time){
        return gUtilityTime.YearMonthDate(time,1)+gUtilityTime.YearMonthDate(time,2)+gUtilityTime.YearMonthDate(time,3)
      },
      ret_YearMonthDateHoursMin(time){
        return gUtilityTime.YearMonthDate(time,4)+gUtilityTime.YearMonthDate(time,5)
      },
      // 修改信息
      modify_information(row){
        console.log(row)
        if(row.modify_time!=0){
          if(row.is_disabled==1){
            row.is_disabled=0
          }else{
            this.startGame_modify(row)
          }
        }else{
          this.startGame_modify(row)
        }

        return;
      },
      //添加场次
      AddOstentation(){
        var _this = this;
        if(this.shop_game_value==''){
          this.$message({
            message: '请选择游戏',
            type: 'warning'
          });
          return
        }
        if(this.value1==null || this.value1==''){
          this.$message({
            message: '请选择时间',
            type: 'warning'
          });
          return
        }
        _this.open_wait_for(1);
        if(this.modify_time_data!=''){
          protocol_ZgrShopOstentationOrder_eidt(
          _this.config_hall_type,
          (new Date(this.value1).getTime())/1000,
          ((new Date(this.value1).getTime())+(this.time_value*60*1000))/1000,
          gGameData.getDataByName(this.shop_game_value).id,
          this.modify_time_data.id,
          this.Playwith_value,
           _this.aftert_pay_status==true?1:0
          ).then(res=>{
            _this.open_wait_for(2);
            if(res.code==0){
              _this.$message({
                message: '添加成功',
                type: 'success'
              });
              _this.dialogFormVisible_paichang=false;
              _this.modify_time_data='';
              _this.init_list(_this.radio1);
            }
          })
        }else{
          protocol_ZgrShopOstentationOrder_add(
          _this.config_hall_type,
          (new Date(this.value1).getTime())/1000,
          ((new Date(this.value1).getTime())+(this.time_value*60*1000))/1000,
          gGameData.getDataByName(this.shop_game_value).id,
          this.Playwith_value,
           _this.aftert_pay_status==true?1:0
          ).then(res=>{
            _this.open_wait_for(2);
            if(res.code==0){
              _this.$message({
                message: '添加成功',
                type: 'success'
              });
              _this.dialogFormVisible_paichang=false;
              _this.init_list(_this.radio1);
            }
          })
        }
      },
      startGame_modify_verification(row){
        //if(row.people_source==1 || row.people_source==2 || row.people_source==3 || row.people_source==12 || row.people_source==13){
        if(row.people_source!=11 && row.payment_serial_number!=null){
          if(row.payment_serial_number.length>=8){
            return false
          }
        }
        // if(row.people_source==4 ||row.people_source==5||row.people_source==6||row.people_source==7||row.people_source==8||row.people_source==9||row.people_source==10){
        //   if(row.thrid_party_code.length<5){
        //     return false
        //   }
        // }
        if(row.people_source==11&& row.payment_serial_number!=null){
          if(row.remarks==null || row.remarks==""){
            return false
          }
        }
        if(row.people_source==undefined){
          return false
        }
        return true
      },
      //修改提交
      startGame_modify(row){
        var _this = this;
        if(row.net_receipts<0){
          this.$message({
            message: '实收金额不能小于0',
            type: 'warning'
          });
          return false
        }
        if(row.net_receipts===''){
          this.$message({
            message: '实收金额不能为空',
            type: 'warning'
          });
          return false
        }
        if(row.net_receipts>row.turnover){
          this.$message({
            message: '实收金额不能大于应付金额',
            type: 'warning'
          });
          return false
        }

       if(row.people_source!=11){
          if(row.payment_serial_number==null || row.payment_serial_number==""){
            this.$message({
              message: '订单号不能为空',
              type: 'warning'
            });
            return false
          }
        }

        if(row.people_source==11){
          if(row.remarks==null || row.remarks==""){
            this.$message({
              message: '备注不能为空',
              type: 'warning'
            });
            return false
          }
        }
        if(row.payment_mode==0){
          this.$message({
            message: '请选择付款方式',
            type: 'warning'
          });
          return false
        }
        let waiter="";

        if (Array.isArray(row.waiter))
        {

          if(row.waiter.length==1)
          {
            waiter=row.waiter;
          }else if(row.waiter.length==0)
          {
            waiter="";
          }
          else{
            for (var i = 0; i < row.waiter.length; i++) {
                 waiter+=row.waiter[i];
                 if(i<(row.waiter.length-1))
                 {
                   waiter+=";"
                 }
            }
           }
        }

        _this.open_wait_for(1);
        protocol_ZgrShopOstentation_eidt(
        row.ostentation_detail_id,
        row.phone,
        row.people_count,
        row.net_receipts,
        row.payment_mode,
        row.people_source,
        row.remarks,
        row.thrid_party_code,
        row.turnover,
        row.offline_conversion,
        row.payment_serial_number,
        row.hall_type,
        row.extra_money,
        row.extra_money_type,
        //row.waiter,
        waiter,
        row.private_domain
        ).then(res=>{
          _this.open_wait_for(2);
          if(res.code==0){
            _this.$message({
              message: '修改成功',
              type: 'success'
            });
            row.is_disabled=1;
            row.modify_time=1;
            for(let i=0;i<_this.tableData.length;i++){
              if(_this.tableData[i].ostentation_detail_id==row.ostentation_detail_id){
                _this.tableData[i].is_disabled==1
                _this.tableData[i].modify_time=1;
              }
            }
            let is_verification=[];
            for(let i=0;i<_this.tableData.length;i++){
              if(_this.tableData[i].ostentation_detail_id==row.ostentation_detail_id){
                if(_this.tableData[i].is_disabled==1){
                  is_verification.push(_this.startGame_modify_verification(_this.tableData[i]))
                }else{
                  is_verification.push(false)
                }
              }
            }
            if(is_verification.indexOf(false)==-1){
              for(let i=0;i<_this.tableData.length;i++){
                if(_this.tableData[i].ostentation_detail_id==row.ostentation_detail_id){
                   _this.tableData[i].is_show_hide=0
                }
              }
            }
            console.log(is_verification)
          }
        })
      },
      //提交详细
      startGame() {
        var _this = this;
        _this.open_wait_for(1);
        protocol_ZgrShopOstentation_add(
        this.modify_time_data.id,
        1,
        1,
        '',
        0,
        5,
        '',
        '',
        this.get_game_price(this.modify_time_data.game_id),
        0,
        this.modify_time_data.aftert_pay_status==1?"待补充":'',
        _this.config_hall_type,
        0,
        1,
        '',
        ).then(res=>{
          _this.open_wait_for(2);
          if(res.code==0){
            _this.$message({
              message: '添加成功',
              type: 'success'
            });
            _this.dialogFormVisible=false;
            _this.modify_time_data="";
            _this.init_list(_this.radio1);
          }
        })
      },
      //关闭弹窗
      cannelStartGame() {
        this.modify_time_data='';
        this.dialogFormVisible_paichang = false;
        this.dialogFormVisible = false;
        this.dialogFormVisible_modify = false;
      },
      init() {
        this.Account_shop = gAccount.get_Account_shop()
      },
      compare(property){
          return function(a,b){
              var value1 = a[property];
              var value2 = b[property];
              return value1 - value2;
          }
      },
      toFirst(fieldData,index) {
          if(index!=0){
              fieldData.unshift(fieldData.splice(index , 1)[0]);
          }
      },
      //获取基础数据
      init_list(time,is_show){
        let start='';
        let end='';
        if(is_show==undefined){
          is_show=true
        }
        if(time=='全部'){
          start=new Date(gUtilityTime.SameDay(this.DaySafter_list[1],1)).getTime()/1000
          end=new Date(gUtilityTime.SameDay(this.DaySafter_list[7],2)).getTime()/1000
        }else{
          start=new Date(gUtilityTime.SameDay(time,1)).getTime()/1000
          end=new Date(gUtilityTime.SameDay(time,2)).getTime()/1000
        }
        let _this=this;
        protocol_ZgrShopOstentationOrder_list(start,end).then(res_paichang=>{
          protocol_ZgrShopOstentation_list(start,end).then(res=>{
            let data=[];
            for(let i=0;i<res_paichang.ret.length;i++){
              let children=[];
              let children_number=0;
              for(let j=0;j<res.ret.length;j++){
                if(res_paichang.ret[i].id==res.ret[j].ostentation_order_id){
                    children.push(res.ret[j])
                    children_number+=1;
                }
              }
              res_paichang.ret[i].children=children
              res_paichang.ret[i].children_number=children_number
            }
            for(let i=0;i<res_paichang.ret.length;i++){
              let totle_people_count=0;
              for(let j=0;j<res_paichang.ret[i].children.length;j++){
                totle_people_count+=res_paichang.ret[i].children[j].people_count
              }
              res_paichang.ret[i].totle_people_count=totle_people_count;
              if(res_paichang.ret[i].children.length==0){
                res.ret.push(res_paichang.ret[i])
              }
            }
            for(let j=0;j<res.ret.length;j++){
              //格式化服务人员
              res.ret[j].waiter =_this.shop_waiter_math( res.ret[j].waiter);
              for(let i=0;i<res_paichang.ret.length;i++){
                if(res_paichang.ret[i].id==res.ret[j].ostentation_order_id){
                  res.ret[j].totle_people_count= res_paichang.ret[i].totle_people_count;
                  res.ret[j].play_with_count= res_paichang.ret[i].play_with_count;
                  res.ret[j].game_id= res_paichang.ret[i].game_id;
                  res.ret[j].hall_type= res_paichang.ret[i].hall_type;
                  res.ret[j].id= res_paichang.ret[i].id;
                  res.ret[j].shop_id= res_paichang.ret[i].shop_id;
                  res.ret[j].time_day= res_paichang.ret[i].time_day;
                  res.ret[j].time_end= res_paichang.ret[i].time_end;
                  res.ret[j].time_month= res_paichang.ret[i].time_month;
                  res.ret[j].time_start= res_paichang.ret[i].time_start;
                  res.ret[j].time_year= res_paichang.ret[i].time_year;
                  res.ret[j].children_number= res_paichang.ret[i].children_number;
                  res.ret[j].order_start_status= res_paichang.ret[i].order_start_status;
                  res.ret[j].is_disabled= 1;
                  res.ret[j].aftert_pay_status= res_paichang.ret[i].aftert_pay_status;
                  res.ret[j].is_show_hide= 0;
                }
              }
            }
            res.ret=res.ret.sort(_this.compare('time_start'))
            let res_data=[];
            for(let i=0;i<res.ret.length;i++){
              if(res.ret[i].hall_type==_this.config_hall_type){
                res_data.push(res.ret[i])
              }
            }
            var newsas = Array.from(
              res_data.reduce((dict, item)=> {
                if (dict.has(item.id)) {
                  dict.get(item.id).push(item)
                } else {
                  dict.set(item.id, [item])
                }
                return dict
              }, new Map())
            ).map(item => ({child: item[1], id: item[0]}))
            console.log(newsas)
            let is_verification=[];
            for(let i=0;i<newsas.length;i++){
              let is_verification_num=0
              for(let j=0;j<newsas[i].child.length;j++){
                console.log(newsas[i].child[j])
                if(_this.startGame_modify_verification(newsas[i].child[j])==true){
                  is_verification_num+=1
                }
              }
              newsas[i].is_verification_num=is_verification_num;
            }
            console.log(newsas)
            for(let i=0;i<newsas.length;i++){
              for(let j=0;j<res_data.length;j++){
                if(newsas[i].id==res_data[j].ostentation_order_id && newsas[i].child.length==newsas[i].is_verification_num){
                  res_data[j].is_show_hide=0
                }
              }
            }
            let data_arr1=[],data_arr2=[];
            for(let i=0;i<res_data.length;i++){
              if(res_data[i].order_start_status==2 && res_data[i].aftert_pay_status==1){
                data_arr1.push(res_data[i])
              }else{
                data_arr2.push(res_data[i])
              }
            }
            if(is_show==true){
              var myChildren = res_data;
            }else{
              var myChildren = data_arr1.concat(data_arr2);
            }
            console.log(myChildren)
            _this.tableData=myChildren;
            let turnover_sum1=0;
            let paid_amount_sum1=0;
            let refund_sum1=0;
            let people_sum1=0;
            for(let i=0;i<_this.tableData.length;i++){
              if(_this.tableData[i].children_number!=0){
                if(_this.tableData[i].order_refund_status!=1){
                  turnover_sum1+=Number(_this.tableData[i].turnover);
                  paid_amount_sum1+=Number(_this.tableData[i].net_receipts);
                }
                people_sum1+=Number(_this.tableData[i].people_count);
              }
              if(_this.tableData[i].order_refund_status==1){
                refund_sum1+=1
              }
            }
            _this.turnover_sum=turnover_sum1;
            _this.paid_amount_sum=paid_amount_sum1;
            _this.refund_sum=refund_sum1;
            _this.people_sum=people_sum1;
            _this.mergeLineMethod()
          })
        })
      },
    },
    mounted() {
      this.DaySafter_list=gUtilityTime.DaySafter7();
      this.radio1=this.DaySafter_list[1];
      this.shop_game = gGameData.getAllDataShopDataPrice()
      this.payment_method_agent = payment_methodagent;
      this.init();
      this.get_waiter_data();
    },
    //监控时间单选
    watch:{
      'radio1':function(newVal,oldVal){
        this.init_list(newVal);
      },
      'time_sort':function(newVal,oldVal){
        console.log(newVal)
        this.init_list(this.radio1,newVal);
      },
      'shop_game_value':function(newVal,oldVal){
        for(let i=0;i<this.shop_game.length;i++){
          if(this.shop_game[i].name==newVal){
            this.time_value=this.game_name(this.shop_game[i].id).duration
          }
        }
      },
      'select_value':function(newVal,oldVal){
        this.form.turnover=this.game_price*Number(newVal)
        this.form.paid_amount=this.game_price*Number(newVal)
      },
      'user_source_value':function(newVal,oldVal){
        if(newVal!=4 && newVal!=5 && newVal!=6 && newVal!=7 && newVal!=8  && newVal!=9 ){
           this.is_checked=false
           this.checked=false
           this.form.volume_code=""
        }else{
          this.is_checked=true
        }
        let data=[],data_is=[];
        if(newVal==1 || newVal==2){
          data=[{
              value: 1,
              label: '微信'
            }, {
              value: 2,
              label: '支付宝'
            },{
              value: 3,
              label: '储值卡'
            }]
            data_is=[1,2,3]
            this.payment_method=data;
            if(!this.is_payment_method || data_is.indexOf(this.payment_method_value) == -1 ){
              this.payment_method_value="";
            }
        }else if(newVal==3){
          data=[{
              value: 5,
              label: '贵宾券'
            }]
            data_is=[5]
          this.payment_method=data;
          this.payment_method_value=5;
        }else if(newVal==""){
          this.payment_method=this.payment_method_agent;
          if(!this.is_payment_method){
            this.payment_method_value="";
          }
        }else{
          data=[{
              value: 4,
              label: '线上'
            }]
            data_is=[4]
          this.payment_method=data;
            this.payment_method_value=4;
        }
      },
    }
  }
</script>
<style>
  .bjwarning{
    background: #fbc1c1;
  }
  .el-table .warning-row {
      background: #fbc1c1;
    }
  .el-table .node-row {
    display: none;
  }
  .bjerror{
    background: #aed4eb;
  }
  .el-table .error-row {
    background: #aed4eb;
  }
  .el-table .info-row {
    background: #909399;
  }
  tr:hover td {
    background: none !important;
  }
  .el-table td, .el-table th{
    padding: 2px 0 !important;
  }
  .el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
    border-color: #b2d9b2;
  }
  .el-table--border::after, .el-table--group::after, .el-table::before{
    background-color: #b2d9b2;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PaiChangCurrent2.vue